import { render, staticRenderFns } from "./transferliste.vue?vue&type=template&id=1b2d7fc8&scoped=true&"
import script from "./transferliste.vue?vue&type=script&lang=js&"
export * from "./transferliste.vue?vue&type=script&lang=js&"
import style0 from "./transferliste.vue?vue&type=style&index=0&id=1b2d7fc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d7fc8",
  null
  
)

export default component.exports